import { render, staticRenderFns } from "./DIAGComparacaoETAs.vue?vue&type=template&id=eadb153a&"
import script from "./DIAGComparacaoETAs.vue?vue&type=script&lang=js&"
export * from "./DIAGComparacaoETAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports